module.exports = __webpack_public_path__ + "fonts/THICCCBOI-SemiBold.b5107db1.ttf";